<template>
  <div class="page-container">
    <!-- 头部容器 -->
    <div class="header-container">
      <!-- 标题 -->
      <div class="title-container">
        <span class="symbol-icon"></span>
        <span class="title-text">{{ $str.getKey('收益管理/选择生效月份') }}</span>
      </div>
    </div>

    <!-- 主体容器 -->
    <div class="main-container">
      <div class="panel-container common-panel">
        <div class="title-container">{{ $str.getKey('收益管理/常规') }}</div>
        <div class="table-container">
          <el-table :data="tabelData.common" stripe class="table-com">
            <el-table-column prop="month" :label="$str.getKey('收益管理/月份')" width="140px" />
            <el-table-column prop="segments.sharp" :label="$str.getKey('收益管理/规则')">
              <template #default="{ row }">
                <div class="segment-cell">
                  <el-select v-model="row.ruleId" value-key="id" clearable :placeholder="$str.getKey('收益管理/请选择规则')" @change="handleDateRuleChange(row)">
                    <el-option v-for="item in tabelData.ruleList" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="panel-container holiday-panel" v-loading="loading">
        <div class="title-container">{{ $str.getKey('收益管理/节假日') }}</div>
        <div class="table-container">
          <el-table :data="tabelData.holiday" stripe class="table-com">
            <el-table-column prop="name" :label="$str.getKey('收益管理/节日')" width="140px" />
            <el-table-column prop="dateRange" :label="$str.getKey('收益管理/日期')">
              <template #default="{ row }">
                <div class="segment-cell">
                  <div>{{row.dateRange[0]}} ~ {{row.dateRange[1]}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="segments.sharp" :label="$str.getKey('收益管理/规则')">
              <template #default="{ row }">
                <div class="segment-cell">
                  <el-select v-model="row.ruleId" value-key="id" clearable :placeholder="$str.getKey('收益管理/请选择规则')" @change="handleDateRuleChange(row)">
                    <el-option v-for="item in tabelData.ruleList" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="panel-container dayoff-panel">
        <div class="title-container">{{ $str.getKey('收益管理/休息日') }}</div>
        <div class="table-container">
          <el-table :data="tabelData.dayoff" stripe class="table-com">
            <el-table-column prop="month" :label="$str.getKey('收益管理/月份')" width="140px" />
            <el-table-column prop="segments.sharp" :label="$str.getKey('收益管理/规则')">
              <template #default="{ row }">
                <div class="segment-cell">
                  <el-select v-model="row.ruleId" value-key="id" clearable :placeholder="$str.getKey('收益管理/请选择规则')" @change="handleDateRuleChange(row)">
                    <el-option v-for="item in tabelData.ruleList" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, nextTick, onMounted, defineProps } from "vue"
import dayjs from 'dayjs';
import { querySpecialDaysForYear } from "../api/index.js";

const $str = window.$str;

const emit = defineEmits(['dateRuleChange']); // 声明：事件

/** 属性传递：接收父组件传递下来的数据 */
const props = defineProps({
  year: {
    type: [Object, String],
    default: ''
  },
  ruleList: {
    type: Array,
    default: []
  },
});

const loading = ref(false); // 加载中

const tabelData = reactive({
  common: [], // 常规
  dayoff: [], // 周末
  holiday: [], // 法定节假日
  loanedDay: [], // 法定补班日
  ruleList: [], // 规则列表
})



watch(() => props.year, nv => {
  refreshDateList(nv);
},{immediate:true})

watch(() => props.ruleList, nv => {
  tabelData.ruleList = nv;
},{immediate:true, deep:true})



init()

/** ====== [业务：功能方法] =================================================================== */
async function init() {
  // // 初始化：常规日 | 节假日
  // for (let month = 1; month <= 12; month++) {
  //   tabelData.common.push({
  //     type: 'common',
  //     month,
  //     ruleId: '',
  //   });
  //   tabelData.dayoff.push({
  //     type: 'dayoff',
  //     month,
  //     ruleId: '',
  //   });
  // }

  // await refreshHolidayList();

  // const holidayList = [
  //   {
  //     type: 'holiday',
  //     name: '元旦',
  //     dateRange: ['2025-01-01', '2025-01-01'],
  //     ruleId: '',
  //   },
  //   {
  //     type: 'holiday',
  //     name: '春节',
  //     dateRange: ['2025-01-28', '2025-02-04'],
  //     ruleId: '',
  //   },
  //   {
  //     type: 'holiday',
  //     name: '清明节',
  //     dateRange: ['2025-04-04', '2025-04-06'],
  //     ruleId: '',
  //   },
  //   {
  //     type: 'holiday',
  //     name: '劳动节',
  //     dateRange: ['2025-05-01', '2025-05-05'],
  //     ruleId: '',
  //   },
  //   {
  //     type: 'holiday',
  //     name: '端午节',
  //     dateRange: ['2025-05-31', '2025-06-02'],
  //     ruleId: '',
  //   },
  //   {
  //     type: 'holiday',
  //     name: '国庆节、中秋节',
  //     dateRange: ['2025-10-01', '2025-10-08'],
  //     ruleId: '',
  //   },
  // ];

  // tabelData.holiday = holidayList;

}



async function refreshDateList(year) {
  clearDayInfo();
  // 初始化：常规日 | 节假日
  for (let month = 1; month <= 12; month++) {
    tabelData.common.push({
      type: 'common',
      month,
      ruleId: '',
    });
    tabelData.dayoff.push({
      type: 'dayoff',
      month,
      ruleId: '',
    });
  }

  // 初始化节假日
  loading.value = true;
  await querySpecialDaysForYear(year, [3,4]).then(res => {
    if (Array.isArray(res.data)) {
      const holidayList = [];
      const loanedList = [];

      res.data.forEach(it => {
        if (it.type === 3) {
          const holiday = {
            type: 'holiday',
            name: it.name, // '元旦
            dateRange: [it.startDate, it.endDate], // ['2025-01-01', '2025-01-01'],
            ruleId: '',
          }
          holidayList.push(holiday);
        }
        if (it.type === 4) {
          const loanedDay = {
            type: 'loanedDay',
            name: it.name, // 名称统一为：'补班'
            dateRange: [it.startDate, it.endDate], // ['2025-01-01', '2025-01-01'],
            ruleId: '', // 监听当月common-day使用的规则变化，取该规则ID
          }
          loanedList.push(loanedDay);
        }
      })
      tabelData.holiday = holidayList;
      tabelData.loanedDay = loanedList;
    }

  }).finally(() => {
    loading.value = false;
  })
}


function handleDateRuleChange(data) {
  const cfgData = {
    common: tabelData.common,
    dayoff: tabelData.dayoff,
    holiday: tabelData.holiday,
    loanedDay: tabelData.loanedDay,
  }
  emit('dateRuleChange', cfgData);
}




/** ====== [辅助：功能方法] =================================================================== */

/** 清空日期信息 >>> 当year变化时，先清空，再获取 */
function clearDayInfo() {
  tabelData.common = [];
  tabelData.dayoff = [];
  tabelData.holiday = [];
  tabelData.loanedDay = [];
}


</script>
<style lang="scss" scoped>
.page-container {
  --header-hight: 50px;
  & {
    width: 100%;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(10px);
    padding: 10px;
  
    border-radius: 20px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .header-container {
    width: 100%;
    height: var(--header-hight);
    min-height: var(--header-hight);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-container {
      max-width: 50%;
      height: 100%;
      padding-left: 6px;
      display: flex;
      align-items: center;
      gap: 10px;

      .symbol-icon {
        width: 4px;
        height: 20px;
        background: #485e91;
      }
      .title-text {
        font-size: 18px;
      }
    }

  }


  .main-container {
    & {
      width: 100%;
      // height: 400px;
      display: flex;
      justify-content: space-between;
      gap: 10px;
    }
    .panel-container {
      & {
        height: 100%;
        box-sizing: border-box;
        padding: 0px;
        background: var(--level2-bg-color);
          border: 1px solid rgba(0, 0, 0, 0.08);
        display: flex;
        flex-direction: column;
      }

      
      &.common-panel {
        width: 30%;
      }

      &.holiday-panel {
        width: 40%;
      }

      &.dayoff-panel {
        width: 30%;
      }

      .title-container {
        width: 100%;
        height: 40px;
        padding: 0 20px;
        background: var(--level3-bg-color, rgba(58, 104, 255, 0.08));
        color: rgba(46, 46, 46, 0.82);
        font-size: 16px;
        font-weight: bold;
        display: flex;
        align-items: center;
      }

      .table-container {
        width: 100%;
        height: 100%;
        flex: 1;
      }

      ::v-deep .el-table {
        .el-table__cell {
          .cell {
            display: block;
          }
        }
      }

      /* 表格内下拉：占满单元格宽度，避免只剩一个箭头 */
      ::v-deep .segment-cell {
        width: 100%;
      }

      ::v-deep .segment-cell .el-select {
        width: 100%;
      }
    }


  }

}
</style>
